import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBxqLRnvWatUybb_yO-xvH1Z49K3-UU-cM",
  authDomain: "lead-database-bf560.firebaseapp.com",
  projectId: "lead-database-bf560",
  storageBucket: "lead-database-bf560.firebasestorage.app",
  messagingSenderId: "597487725020",
  appId: "1:597487725020:web:47c7f5e38a1ef8442f4719"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;